import { Icon } from '@acme/assets';

interface ErrorMessageProps {
  title: string;
  message?: string;
}

export const ErrorMessage = ({ title, message }: ErrorMessageProps) => {
  return (
    <div className="flex flex-col items-center gap-4 py-6 w-72">
      <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center m-16">
        <Icon name="x-outline" size={24} className="text-red-600 " />
      </div>
      <div className="flex flex-col gap-2 text-center">
        <h3 className="font-medium text-gray-900">{title}</h3>
        {message && <p className="text-base text-gray-500">{message}</p>}
      </div>
    </div>
  );
};
